(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mensch-black-november"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',async event=>{
  const button=event.target.closest('[data-black-copy]');
  if(!button)return;
  const code=button.dataset.blackCopy;
  const status=button.closest('[data-black-november]').querySelector('[data-black-copy-status]');
  const label=button.querySelector('.mch-black-november__code');
  try{
    try{await navigator.clipboard.writeText(code);}
    catch{
      const input=document.createElement('textarea');
      input.value=code;input.readOnly=true;input.style.cssText='position:fixed;opacity:0;pointer-events:none';
      document.body.append(input);input.select();
      const copied=document.execCommand('copy');input.remove();button.focus({preventScroll:true});
      if(!copied)throw new Error('copy');
    }
    status.textContent=button.dataset.copied;
    if(!button.dataset.copyPending){
      button.dataset.copyPending='true';
      const original=label.innerHTML;label.textContent=code+' ✓';
      setTimeout(()=>{label.innerHTML=original;delete button.dataset.copyPending;},2200);
    }
  }catch{status.textContent=code;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mensch-hero-carousel"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('mensch-hero-carousel')) {
  customElements.define('mensch-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-go]')];
      this.toggle = this.querySelector('[data-toggle]');
      if (this.slides.length < 2) return;
      this.index = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.inView = true;
      this.hovered = false;
      this.focused = false;
      this.editing = false;
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => { this.show(index); this.schedule(); }, options));
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', () => queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); }), options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        this.schedule();
      }, options);
      this.addEventListener('touchstart', (event) => { this.preventLinkUntil = 0; this.touchX = event.touches[0].clientX; this.touchY = event.touches[0].clientY; clearTimeout(this.timer); }, { ...options, passive: true });
      this.addEventListener('touchend', (event) => {
        const dx = event.changedTouches[0].clientX - this.touchX;
        const dy = event.changedTouches[0].clientY - this.touchY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) { this.preventLinkUntil = performance.now() + 700; this.show(this.index + (dx < 0 ? 1 : -1)); }
        this.schedule();
      }, { ...options, passive: true });
      this.addEventListener('click', (event) => { if (performance.now() < (this.preventLinkUntil || 0) && event.target.closest('.mch-image-link')) { event.preventDefault(); event.stopPropagation(); } }, { ...options, capture: true });
      this.addEventListener('touchcancel', () => this.schedule(), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', (event) => { if (event.matches) this.paused = true; this.updateToggle(); this.schedule(); }, options);
      this.observer = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting; this.schedule(); }, { threshold: 0.15 });
      this.observer.observe(this);
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.editing = true;
        this.show(index);
        this.schedule();
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editing = false; this.schedule(); }, options);
      this.classList.add('is-ready');
      this.updateToggle();
      this.schedule();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        this.dots[i].setAttribute('aria-current', String(active));
      });
    }
    updateToggle() {
      this.toggle.classList.toggle('is-paused', this.paused);
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.querySelector('.mch-slides').setAttribute('aria-live', this.paused ? 'polite' : 'off');
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || this.editing || !this.inView || document.hidden) return;
      this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, Number(this.dataset.interval) || 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
